(() => {
    // skip jointmomentum it should always be the brand
    const companies = ["blish", "brand", "impact", "june", "leap", "limmat", "morrow", "none", "tech", "morning"];

    const colors = [
        "255 190 35",
        "255 125 0",
        "255 0 0",
        "255 50 180",
        "150 100 255",
        "0 145 255",
        "0 230 255",
        "45 220 140",
        "0 225 0",
    ];

    let availableColors = [...colors];

    const usedColors = [];

    const assignments = {};

    companies.forEach((company) => {
        if (availableColors.length === 0) {
            availableColors = usedColors;
        }
        const selected = availableColors.splice(Math.floor(Math.random() * availableColors.length), 1)[0];
        usedColors.push(selected);
        assignments[company] = selected;
    });

    const colorStyles = document.createElement("style");
    colorStyles.textContent = `:root{--company-jointmomentum:var(--color-brand-650);${Object.entries(assignments)
        .map(([name, color]) => `--company-${name}: ${color};`)
        .join("")}}`;
    document.head.prepend(colorStyles);

    const linkColor = document.createElement("style");
    linkColor.textContent = `:root{--fancy-color: #00e6ff}`;
    document.head.prepend(linkColor);

    let linkColorIndex = 0;

    function generateNewLinkColor() {
        let index = Math.floor(Math.random() * colors.length);
        if (index === linkColorIndex) {
            index = (index + 1) % colors.length;
        }
        linkColor.textContent = `:root{--fancy-color: ${colors.slice(index, index + 1)}}`;
        linkColorIndex = index;
    }

    document.addEventListener("DOMContentLoaded", () => {
        [
            ...document.querySelectorAll(
                ".c-bodytext a:not(.c-button),.c-bodytext--hightlight-links a,.fancy-activator"
            ),
        ].forEach((element) => element.addEventListener("mouseleave", generateNewLinkColor));
    });

    generateNewLinkColor();
})();
